<script setup lang="ts">
import sha256 from "crypto-js/sha256";
import Base64 from "crypto-js/enc-base64";
import config from "@/config";
import { useRoute } from "vue-router";
import { generateRandomString } from "@/utils";
import { isLoggedIn, refreshToken } from "@/login";
const route = useRoute();

const generateCodeChallenge = (code_verifier: string): string => {
  const hash = sha256(code_verifier);
  return Base64.stringify(hash)
    .replace(/=/g, "")
    .replace(/\+/g, "-")
    .replace(/\//g, "_");
};

const generateCodeVerifier = (): string => {
  return generateRandomString(128);
};

const login = () => {
  const host = config.unifiedLoginHost;
  const code_verifier = generateCodeVerifier();
  const code_challenge = generateCodeChallenge(code_verifier);
  const state = generateRandomString(12);
  const scope =
    "https://api.postnord.com/scopes/riktigavykort/all offline_access";
  localStorage.setItem("code-verifier", code_verifier);
  const authUrl = `${host}/oauth2/auth?response_type=code&client_id=${config.clientId}&redirect_uri=${config.redirectUri}&scope=${scope}&code_challenge=${code_challenge}&code_challenge_method=S256&state=${state}&ui_locales=sv-SE`;
  console.log(`redirecting to ${authUrl}`);
  window.location.replace(authUrl);
};

if (isLoggedIn()) {
  console.log("already logged in, going home");
  window.location.replace("/");
} else if (await refreshToken()) {
  const redirect = route.query.redirect || ["/"];
  console.log("refresh succeeded, redirecting to " + redirect[0]);
  window.location.replace(redirect[0] || "/");
} else {
  login();
}
</script>

<template>
  <h1>Login</h1>
</template>
